(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/tables/assets/javascripts/collections/statlivematches.js') >= 0) return;  svs.modules.push('/components/statistics/tables/assets/javascripts/collections/statlivematches.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.collections = svs.statistics.collections || {};
  svs.statistics.collections.StatLiveMatches = Backbone.Collection.extend({
    log: new svs.core.log.Logger('svs.statistics.collections.StatLiveMatches'),
    model: svs.statistics.models.Match,
    initialize: function initialize(models, options) {
      var self = this;

      if (options && options.leagueId) {
        this.leagueId = options.leagueId;
        this.url = svs.core.jupiter.url() + this.getLiveMatchesUrl(options.leagueId);
        this.fetch({
          success: function success(collection, response, options) {
            self.log.debug('I am an updated StatLiveMatches collection ', collection, response, options);
          }
        });
      } else if (models) {
        if (svs.utils.ns.isNamespace('league.id', models[0])) {
          this.leagueId = models[0].league.id;
        }

        _.defer(function () {
          self.trigger('liveMatchesFetched');
        });
      }
    },
    parse: function parse(response) {
      this.listenTo(this, 'reset', this.onParseReady);
      this.reset(response.matches);
      return [];
    },
    onParseReady: function onParseReady() {
      this.trigger('liveMatchesFetched');
    },

    getLiveMatchesUrl: function getLiveMatchesUrl(leagueId) {
      var format = 'YYYY-MM-DD[T]HH:mm',
          from = moment().subtract(4, 'hours').format(format),
          to = moment().add(4, 'hours').format(format);
      return "/search/query?ctx=sport_match&type=sport_match&andfilter=payload.match.league.id;".concat(leagueId, "&") + "rangefilter=payload.match.startTime;gte;".concat(from, ",payload.match.startTime;lte;").concat(to, "&sort=payload.match.startTime");
    },

    hasLiveMatches: function hasLiveMatches() {
      var sport = this.models.length > 0 ? _.first(this.models).get('sport') : undefined,
          theme = new svs.sport.themeLoader({
        sport: sport,
        league: this.leagueId
      }),
          firstLiveMatch = _.find(this.models, function (match) {
        return theme.themeFunction('isLive', match.get('status')) || theme.themeFunction('subscribeMatch', {
          time: match.get('startTime'),
          status: match.get('status')
        });
      });

      this.log.debug('hasLiveMatches', firstLiveMatch);
      return firstLiveMatch !== undefined;
    },
    getLiveTeams: function getLiveTeams() {
      var liveTeams = [],
          sport = this.models.length > 0 ? _.first(this.models).get('sport') : undefined,
          theme = new svs.sport.themeLoader({
        sport: sport,
        league: this.leagueId
      });

      _.each(this.models, function (match) {
        if (theme.themeFunction('isLive', match.get('status'))) {
          liveTeams.push(match.get('homeTeam').id);
          liveTeams.push(match.get('awayTeam').id);
        }
      });

      return liveTeams;
    }
  });
})(Backbone, _, svs);
 })(window);